import { PayrollStatus } from '../../../../../../server/src/common/enums';
import { Badge } from '../../../../design-system/badge/badge';
import { exhaustiveCheck } from '../../../../utils/exhaustive-check';

interface PayrollStatusBadgeProps {
  status: PayrollStatus;
  className?: string;
}

const getStatusBadgeVariant = (status: PayrollStatus) => {
  switch (status) {
    case PayrollStatus.SUCCEEDED:
      return 'positive' as const;
    case PayrollStatus.PARTIALLY_SUCCEEDED:
      return 'attention' as const;
    case PayrollStatus.FAILED:
      return 'negative' as const;
    case PayrollStatus.APPROVED:
      return 'info' as const;
    case PayrollStatus.WAITING_FOR_APPROVAL:
      return 'warning' as const;
    case PayrollStatus.IN_DRAFT:
      return 'neutral' as const;
    default:
      return exhaustiveCheck(status);
  }
};

const getStatusLabel = (status: PayrollStatus) => {
  switch (status) {
    case PayrollStatus.SUCCEEDED:
      return 'Paid';
    case PayrollStatus.PARTIALLY_SUCCEEDED:
      return 'Partially Paid';
    case PayrollStatus.FAILED:
      return 'Failed';
    case PayrollStatus.APPROVED:
      return 'To Pay';
    case PayrollStatus.WAITING_FOR_APPROVAL:
      return 'Needs Approval';
    case PayrollStatus.IN_DRAFT:
      return 'Draft';
    default:
      return exhaustiveCheck(status);
  }
};

export const PayrollStatusBadge = ({ status, className }: PayrollStatusBadgeProps) => {
  return (
    <Badge variant={getStatusBadgeVariant(status)} className={className} shape="pill">
      {getStatusLabel(status)}
    </Badge>
  );
};
